import * as types from '../types'

const initialState = {
    loading: false,
    data: [],
    status: null,
    error: {},
}

const fetchNotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_NOTIFICATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: {},
            }

        case types.FETCH_NOTIFICATION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                status: action.payload.status,
            }
        case types.FETCH_NOTIFICATION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            }
        default:
            return state
    }
}

export default fetchNotificationReducer
